import { render, staticRenderFns } from "./RecipeRegistration.vue?vue&type=template&id=7aa7ba33&scoped=true"
import script from "./RecipeRegistration.vue?vue&type=script&lang=js"
export * from "./RecipeRegistration.vue?vue&type=script&lang=js"
import style0 from "./RecipeRegistration.vue?vue&type=style&index=0&id=7aa7ba33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa7ba33",
  null
  
)

export default component.exports